import { render, staticRenderFns } from "./InscriptionMerits.html?vue&type=template&id=4577bc42&external"
import script from "./InscriptionMerits.ts?vue&type=script&lang=ts&external"
export * from "./InscriptionMerits.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports